export const PASSWORD_REGEX = /^((?=.*[a-z])(?=.*\d)(?=.*[A-Z])(?!.*\s).{8,64})$/;
export const EMAIL_REGEX = /^[\w!#$%&'*+./=?^`{|}~-]+@[\dA-Za-z](?:[\dA-Za-z-]{0,61}[\dA-Za-z])?(?:\.[\dA-Za-z](?:[\dA-Za-z-]{0,61}[\dA-Za-z])?)*$/;
export const ISNUMBER = /^\d*$/;
